import axios from './axios';
// import { userData } from "./Currentuserdata";

export default {
  /**
   * Get all lots
   * @api {Get} realstate/lots
   * @param {object} params
   */
  getLots(params) {
    const options = {
      method: 'GET',
      url: 'realstate/lots',
      headers: { 'content-type': 'application/json' },
      params,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.log(error)
          reject(error.message);
        })
    });
  },

  addLotSale(data) {
    const options = {
      method: 'POST',
      url: 'realstate/lot/sale',
      headers: {'content-type': 'application/json'},
      data
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.message);
        })
    });
  },

  getLotFinancing(lotId) {
    const options = {
      method: 'GET',
      url: 'realstate/lot/financing',
      headers: { 'content-type': 'application/json' },
      params: {
        lotId,
      },
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.log(error)
          reject(error.message);
        })
    });
  },

  getPlanBalance(planId) {
    const options = {
      method: 'GET',
      url: 'realstate/lot/balance',
      headers: { 'content-type': 'application/json' },
      params: {
        planId,
      },
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.log(error)
          reject(error.message);
        })
    });
  },

  /**
   * Get specific customer lots
   * @api {Get} realstate/lots/by-customer
   * @param {object} params
   */
  getCustomerLots(params) {
    const options = {
      method: 'GET',
      url: 'realstate/lots/by-customer',
      headers: { 'content-type': 'application/json' },
      params,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          console.log(response)
          resolve(response.data);
        })
        .catch(error => {
          console.log(error)
          reject(error.message);
        })
    });
  },

  /**
   * Add new lot
   * @api {POST} realstate/lot
   * @param {object} data new lot's data
   */
  addLot(data) {
    const options = {
      method: 'POST',
      url: 'realstate/lot',
      headers: {'content-type': 'application/json'},
      data
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.message);
        })
    });
  },

  /**
   * Update lot
   * @api {POST} realstate/lot/update
   * @param {object} data update data
   */
  updateLot(data) {
    const options = {
      method: 'POST',
      url: 'realstate/lot/update',
      headers: {'content-type': 'application/json'},
      data
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.message);
        })
    });
  },

  /**
   * Refinance lot
   * @api {POST} realstate/lot/refinance
   * @param {object} data refinance data
   */
  refinanceLot(data) {
    const options = {
      method: 'POST',
      url: 'realstate/lot/refinance',
      headers: {'content-type': 'application/json'},
      data,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.message);
        })
    });
  },

  /**
   * Delete lot
   * @api {POST} realstate/lot/delete
   * @param {object} data delete data
   */
  deleteLot(data) {
    const options = {
      method: 'POST',
      url: 'realstate/lot/delete',
      headers: {'content-type': 'application/json'},
      data
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.message);
        })
    });
  },

  getSaleTypes() {
    return [
      {
        SaleTypeName: 'Contado',
        ID_RealStateSaleType: 'upfront',
      },
      {
        SaleTypeName: 'Crédito',
        ID_RealStateSaleType: 'credit',
      },
      {
        SaleTypeName: 'Financiamiento',
        ID_RealStateSaleType: 'financing',
      }
    ];
  },

  getReservationTypes() {
    return [
      {
        ReservationTypeName: 'Inicial',
        ID_RealStateReservationType: 'initial',
      },
      {
        ReservationTypeName: 'Total',
        ID_RealStateReservationType: 'total',
      },
      {
        ReservationTypeName: 'Parcial',
        ID_RealStateReservationType: 'partial',
      }
    ];
  },

  /**
   * Get all installments
   * @api {Get} realstate/installments
   * @param {object} params
   */
  getInstallments(params) {
    console.log('api get installments')
    const options = {
      method: 'GET',
      url: 'realstate/installments',
      headers: { 'content-type': 'application/json' },
      params,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.log(error)
          reject(error.message);
        })
    });
  },

  /**
   * Add new installment
   * @api {POST} realstate/installment
   * @param {object} data new installment's data
   */
  addInstallment(data) {
    const options = {
      method: 'POST',
      url: 'realstate/installment',
      headers: {'content-type': 'application/json'},
      data
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.message);
        })
    });
  },

  /**
   * Update installment
   * @api {POST} realstate/installment/update
   * @param {object} data update data
   */
  updateInstallment(data) {
    const options = {
      method: 'POST',
      url: 'realstate/installment/update',
      headers: {'content-type': 'application/json'},
      data
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.message);
        })
    });
  },

   /**
   * Process installment payment
   * @api {POST} realstate/installment/pay
   * @param {object} data update data
   */
  processInstallmentPayment(data) {
    const options = {
      method: 'POST',
      url: 'realstate/lot/pay',
      headers: {'content-type': 'application/json'},
      data
    };

  return new Promise((resolve, reject) => {
    axios(options)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.message);
      })
    });
  },

  /**
   * Delete installment
   * @api {POST} realstate/installment/delete
   * @param {object} data delete data
   */
  deleteInstallment(data) {
    const options = {
      method: 'POST',
      url: 'realstate/installment/delete',
      headers: {'content-type': 'application/json'},
      data
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.message);
        })
    });
  },

  /**
   * Get bill history for a lot
   * @api {Get} realstate/installments
   * @param {object} params
   */
  getLotBilling(params) {
    const options = {
      method: 'GET',
      url: 'realstate/billing/by-lot',
      headers: { 'content-type': 'application/json' },
      params,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.log(error)
          reject(error.message);
        })
    });
  },
};